import get from 'lodash/get';
import {
  CLEAR_STORE,
  LOAD_USER_STATUS,
  USER_DATA_LOADED,
  NON_HARD_MIGRATED_SME_FLOW,
  APP_MIGRATION_ENABLED,
  SHOW_APP_MIGRATION,
  UPDATE_AADHAR_OTP_VERIFICATION_ATTEMPTS,
  SET_USER_TIER,
  TOGGLE_IS_UTILITY_API_CALLED,
  SET_BUSINESS_PAYMENT_METHODS
} from '../../action-contants';

export default function userStatusReducer(state = {}, action) {
  switch (action.type) {
    case CLEAR_STORE: {
      return {};
    }
    case LOAD_USER_STATUS: {
      let additionalInfo;
      if (action.data.country_code === 'IN') {
        const aadhar_otpverification_attempts = get(
          action.data,
          'additional_info.aadhar_otpverification_attempts',
          '0'
        );
        additionalInfo = {
          additional_info: { ...action.data?.additional_info, aadhar_otpverification_attempts }
        };
      }
      return {
        ...state,
        ...action.data,
        ...additionalInfo
      };
    }

    case USER_DATA_LOADED: {
      return { ...state, remitterInfoDataLoaded: action.data };
    }
    case NON_HARD_MIGRATED_SME_FLOW: {
      return {
        ...state,
        nonHardMigratedSMEFlow: action.data
      };
    }
    case APP_MIGRATION_ENABLED: {
      return {
        ...state,
        isAppMigrationEnabled: action.data
      };
    }
    case SHOW_APP_MIGRATION: {
      return {
        ...state,
        showAppMigration: action.data
      };
    }
    case UPDATE_AADHAR_OTP_VERIFICATION_ATTEMPTS: {
      return {
        ...state,
        additional_info: {
          ...action.data.additional_info,
          aadhar_otpverification_attempts: action.data
        }
      };
    }
    case SET_USER_TIER: {
      return {
        ...state,
        nthTransactionTier: action.data
      };
    }
    case TOGGLE_IS_UTILITY_API_CALLED: {
      return {
        ...state,
        isUtilityApiCalled: action.data
      };
    }
    case SET_BUSINESS_PAYMENT_METHODS: {
      return {
        ...state,
        businessPaymentMethods: action.data
      };
    }
    default:
      return state;
  }
}
